function initRelatedProductSwatches() {
  document.querySelectorAll('[id^="related-product-swatches-json-"]').forEach((jsonEl) => {
    const uniqueId = jsonEl.id.replace('related-product-swatches-json-', '');
    const variantTemplate = document.getElementById('variant-input-example-' + uniqueId);
    if (!variantTemplate || variantTemplate.dataset.rendered === 'true') return;

    variantTemplate.dataset.rendered = 'true';
    const relatedProductsData = JSON.parse(jsonEl.textContent);
    const currentProductUrl = window.location.pathname; // Safe default for homepage/collections

    relatedProductsData.forEach((product) => {
      const swatch = variantTemplate.cloneNode(true);
      swatch.removeAttribute('id');
      swatch.style = '';

      const link = swatch.querySelector('a.variant__button-label');
      if (link) {
        link.href = product.url;
        link.title = product.title;
        if (product.url === currentProductUrl) link.classList.add('active');
        if (!product.available) link.classList.add('disabled');
      }

      const image = swatch.querySelector('img');
      if (image) {
        image.src = product.featured_image;
        image.alt = product.title;
      }

      const title = swatch.querySelector('.swatch-title');
      if (title) title.textContent = product.title;

      variantTemplate.parentNode.insertBefore(swatch, variantTemplate.nextSibling);
    });
  });
}

// Run once on page load
document.addEventListener('DOMContentLoaded', initRelatedProductSwatches);

// Re-run after Edge’s AJAX load more
document.addEventListener('ajax:loadmore', initRelatedProductSwatches);

// Fallback for any dynamically injected products (if Edge doesn’t trigger an event)
const observer = new MutationObserver(() => initRelatedProductSwatches());
observer.observe(document.body, { childList: true, subtree: true });